import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Tag, Empty } from "antd";
import SkeletonBox from "../SkeletonBox";
import CardTitle from "../CardTitle";
import LoadingIndicator from "../../components/shared/LoadingIndicator/LoadingIndicator";
import { WebsiteAuditSeoIssue } from "../../deepAnalysis/auditReport/types";
import "./HighPriorityIssues.less"


function getTagDataForPriority(impactScore: number) {
    if (impactScore < 4) {
        return { color: 'green', label: 'LOW' };
    } else if (impactScore >= 4 && impactScore < 7) {
        return { color: 'orange', label: 'MEDIUM' };
    } else {
        return { color: 'red', label: 'HIGH' };
    }
}


type Props = {
    websiteGuid: string;
    isLoading: boolean;
    isRunningDeepAnalysis: boolean;
    topIssues: WebsiteAuditSeoIssue[];
};


export default function HighPriorityIssues({ isLoading, websiteGuid, topIssues, isRunningDeepAnalysis }: Props) {
    const navigate = useNavigate();

    return (
        <div className={"dashboard-high-priority-fixes-box"}>
            {isLoading && <SkeletonBox />}

            {!isLoading && (
                <Card
                    title={
                        <CardTitle
                            title="High Priority Issues"
                            description="SEO issues affecting your website's performance and visibility"
                        />
                    }
                >
                    {isRunningDeepAnalysis ? (
                        <LoadingIndicator
                            detailed
                            text="SEO audit in progress"
                            subTitle="We are currently analyzing your monitored URLs for SEO issues."
                        />
                    ) : (
                        <>
                            {topIssues.length === 0 && (
                                <Empty className="empty-state" image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data" />
                            )}

                            {topIssues.length > 0 && (
                                <div className="top-issues">
                                    {topIssues.map(issue => (
                                        <div key={issue.key} className="issue-container">
                                            <Tag className="priority" color={getTagDataForPriority(issue.relevance).color}>{getTagDataForPriority(issue.relevance).label}</Tag>
                                            <div className="issue">
                                                <div className="title link" onClick={
                                                    () => navigate(
                                                        issue.site_wide ? `/deep-analysis/report/?w_guid=${websiteGuid}#${issue.key}` : `/deep-analysis/failed-check/${issue.key}?w_guid=${websiteGuid}`
                                                    )}
                                                >
                                                    {issue.title}
                                                </div>
                                                <div className="recommendation">{issue.recommendation}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </Card>
            )}
        </div>
    );
}